import { ConfigurationInterface } from './interfaces/configuration';

export const configuration: ConfigurationInterface = {
  platform: 'none',
  env: null,
  apiUrl: null,
  minibarUrl: null,
  pdpFunctionUrl: 'https://liquid-product-v1-7s7rhms6ea-uc.a.run.app',
  checkoutFunctionUrl: 'https://checkout-mw.liquidapp.cloud',
  mapsUrl: 'https://utils.liquidcheckout.com',
  recaptchaV3SiteKey: '6LfSIhEdAAAAAHDK2H80jIua0mJCdkpVheBlPyql',
  clientId: undefined,
};

export const envs = {
  staging: {
    env: 'staging',
    apiUrl: 'https://api-staging.liquidcheckout.com',
    minibarUrl: 'https://cart-api-staging.liquidcheckout.com',
  },
  production: {
    env: 'production',
    apiUrl: 'https://api.liquidcheckout.com',
    minibarUrl: 'https://cart-api.liquidcheckout.com',
  },
};
